import { render, staticRenderFns } from "./checking.vue?vue&type=template&id=0b1ed6dc&scoped=true&"
import script from "./checking.vue?vue&type=script&lang=js&"
export * from "./checking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ed6dc",
  null
  
)

export default component.exports